// components/VoteButton.tsx
import { useAuth } from 'helpers/authContext';
import { shareKeychain } from 'helpers/keychain';
import { shareWithWif } from 'helpers/steem';
import React, { useEffect, useRef, useState } from 'react';
import { isLoggedWithKeychain } from 'services/dsteem-service';
import { useToast } from './ui/use-toast';

type Props = {
  position:string;
  post:any; 
  author:string;
  permlink:string; 
  className?:string;
  onNewError:Function;
  onLogin: () => void; 
  btnText?: string;
  showText?: boolean;
};

const ShareButton = ({position,post, author, permlink,  onLogin, onNewError,className, btnText, showText }: Props) => {
  const [open, setOpen] = useState(false);
  const {toast} = useToast();
  const [shares, setShares] = useState(0);
  const [isSharing, setisSharing] = useState(false);  
  const [isShared, setIsShared] = useState(false); 
  const { user, autologin  } = useAuth(); 
  const handleClick = () => {
    if (!user) {
      onLogin();
    } else {
      if (!isShared) {
        handlePostShare(author, permlink);
      }else {
        toast({
          title: "You already shared this post!",
          description: "The post wasn't shared because you previously did it.",
          variant:"rose_red"
        }); 
        onNewError('You already shared this post'); 
      } 
    }
    setOpen(false);
  };
  let keychainLogin = isLoggedWithKeychain(autologin); 
  const handlePostShare = async (author, permlink) => {  
  
    const voteFn = keychainLogin ? shareKeychain : shareWithWif;
    const account = keychainLogin ? user : autologin; 
    setisSharing(true);
    try {
      const result:any = await voteFn(account,author, permlink);

      if (!result.success) {
        onNewError(result.result?.message || "Error sharing.");
        toast({
          title: "Error sharing post",
          description: result.result?.message,
          variant:"rose_red"
        }); 
        return;
      }
      setIsShared(true);
      setShares(shares+1)
      console.log("Shared successfully!", result);
      toast({
        title: "Post shared successfully!",
        description: "You have shared this post. Find it in your profile.",
        variant:"sky_blue"
      }); 
      
    } catch (error) {
      onNewError("Error sharing: " + error.message);
      toast({
          title: "Error sharing post",
          description: error?.message,
          variant:"rose_red"
        }); 
    }
    setisSharing(false);
  };  
  const menuRef = useRef<HTMLDivElement | null>(null); 
  useEffect(() => { 
    setShares(0);
    setIsShared(false);
    if (post && post.shared_by) {
      let shared = false;
      for (let i = 0; i < post.shared_by.length; i++) {
        const e = post.shared_by[i];
        if (e == user) {
          shared = true;
        }
      }
      setShares(post.shared_by.length);
      setIsShared(shared);
    }
  }, [post, user]); 
  useEffect(() => {
    const handleClickOutside = (event) => {
    const menuNode = menuRef.current;
    if (menuNode && !menuNode.contains(event.target)) {
        setOpen(false);
    }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div  ref={menuRef} className="relative d-inline-block">
      {className?.includes("swipe-btn") && (
        <>
          <button className={`${isShared?'active':''} ${className || ""}`} 
          onClick={() => {
            if (user) {
              !isShared ? setOpen(!open):'';
            }else {
              onLogin();
            }
            
          }}>
            <i className="fas fa-share"  /> 
          </button> 
          <div className="swipe-action-text">
            {!isSharing && (shares || 0)} {(isSharing) && <span className="spinner dark small m-0" />}
          </div>
        </> 
      )}
      {!className?.includes("swipe-btn") && (
        <button className={`btn post-tools ${isShared?'active':''} ${className || ""}`} 
        onClick={() => {
          if (user) {
            !isShared ? setOpen(!open):'';
          }else {
            onLogin();
          }
          
        }}>
          <i className="fas fa-share"  /> 
          {showText && <span className="ml-2">{btnText || 'Share'}</span>}
          {!showText && !isSharing && (shares || 0)} 
          {(isSharing) && <span className="spinner dark small" />}
        </button> 
      )}
      
      {open && (
        <div className={`absolute share-popup-window dropdown-window ${position}`}>
          <div className="share-header">
            <div className="share-icon-wrap">
              <i className="fas fa-share" />
            </div>
            <span className="share-title">Share Post</span>
          </div>
          <div className="share-body">
            <p className="share-confirmation-text">
              Share this post on your feed? This helps the author gain more visibility.
            </p>
          </div>
          <button className="share-submit-btn w-100 mt-2" onClick={handleClick}>
            Confirm Share
          </button>
        </div>
      )}
      
    </div>
    
  );
};

export default ShareButton;
